import api from "../http";
import {message} from "antd";
import {accessRequestForm} from "./constants";

export const onRemoveRequest = async (setRequestAccessData, setIsForbidden, documentId, accessResponses, setAccessResponses, rowId = null) => {
    try {
        const response = await api.delete(`support/remove-access-request/${documentId}`)
        if (response.status === 200) {
            setRequestAccessData((prevPage => ({
                ...prevPage,
                access_form_modal: false,
                access_form: {
                    ...accessRequestForm,
                    status: "rejected"
                }
            })))
            setIsForbidden(true)
            if (accessResponses.length && rowId) {
                setAccessResponses(accessResponses.filter(acc => acc.id !== rowId))
            }
        }
    } catch (e) {
        message.error(e?.response?.data?.message || "Forbidden")
    }
}